import React from 'react';

import { useQuery } from '@betterment/js-runtime';

import FullPageLoader from '../../Shared/components/FullPageLoader';
import { locationAssign } from '../../Shared/path-helpers';
import { urlBuilder } from '../../Shared/urlBuilder';
import { Customer } from '../data';

const ExternalAccountCreationRedirect: React.FC = () => {
  const { data: customer, loading: isCustomerLoading } = useQuery<Customer>(urlBuilder.getCustomer());

  if (!isCustomerLoading && customer) {
    locationAssign(
      urlBuilder.appCheckingExternalAccountSetup.absolute({
        checkingAccountId: customer.account?.id,
      })
    );
  }

  return <FullPageLoader isLoading={true} />;
};

export default ExternalAccountCreationRedirect;
